import React from 'react';
import { StarIcon } from 'icons';

import { IFeedbacks } from 'modules/pro';

interface IProps {
  item?: IFeedbacks;
  feedback?: string;
}

export const Card: React.FC<IProps> = ({ item }) => {
  const rating = Math.min(item?.rating ?? 0, 5);

  return (
    <div className="rounded-xl bg-white p-4">
      <p className="font-semibold">
        {item?.first_name} {item?.last_name}
      </p>
      <div className="mt-1 flex items-center gap-1">
        {[...Array(5)].map((_, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <StarIcon key={i} color={i < rating ? 'fill-yellow-300 text-yellow-300' : 'text-gray-300'} />
        ))}
      </div>
      <p className="mt-5 line-clamp-6 text-sm text-gray-600">{item?.comment}</p>
    </div>
  );
};
